import Hls from "hls.js";
import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from "@angular/core";

@Directive({
  selector: "[icn-hls-src]",
})
export class HlsSrc implements OnChanges, OnDestroy {
  @Input("icn-hls-src")
  hlsSrc = "";

  @Input()
  autoStart = true;
  hls: any;
  retries = 5;
  constructor(private el: ElementRef) {
    if (el.nativeElement.tagName !== "VIDEO") {
      throw new Error("icn-hls-src can be bound only to video element");
    }
    this.loadHls(this.hlsSrc);
  }

  loadHls(url) {
    if (this.hls) {
      this.hls.destroy();
    }

    Hls.DefaultConfig.startPosition = 0;

    this.hls = new Hls();
    this.hls.loadSource(url);
    this.hls.attachMedia(this.el.nativeElement);

    if (this.autoStart) {
      this.hls.on(Hls.Events.MANIFEST_PARSED, () =>
        this.el.nativeElement.play().catch(),
      );
    }

    this.hls.on(Hls.Events.ERROR, (event, data) => {
      switch (data.type) {
        case Hls.ErrorTypes.NETWORK_ERROR:
          if (0 !== this.retries--) {
            setTimeout(() => this.loadHls(url), 10000);
          }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["hlsSrc"]) {
      this.el.nativeElement.pause();
      this.loadHls(this.hlsSrc);
    }
  }

  ngOnDestroy() {
    if (this.hls) {
      this.hls.detachMedia();
      this.hls.destroy();
    }
  }
}
